export enum TicketStatus {
    Unassigned,
    ToDo,
    InProgress,
    Done,
    Closed,
    Cancelled
}
